import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IffhsService } from 'src/app/data-services/iffhs.service';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { UserService } from 'src/app/data-services/user.service';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-add-voting-question',
  templateUrl: './add-voting-question.component.html',
  styleUrls: ['./add-voting-question.component.css']
})
export class AddVotingQuestionComponent implements OnInit {

  votingQuestionForm: FormGroup;
  id: number;
  countryData: any = {};
  searchText: any;
  currentUser: any;
  loading = false;
  submitted = false;
  isSubmitted = true;
  errorMessage: string = '';
  visible = true;
  items = [];
  pageOfItems: Array<any>;

  domElement: string = 'view';
  selectedQuestion: any = {};
  questions = [];
  eventQuestions = [];
  questionsAnnual: any;
  isLoaderVisible = false;
  models = [
    {
      id: 1,
      model: 'Referee'
    },
    {
      id: 2,
      model: 'Coach'
    },
    {
      id: 3,
      model: 'Goalkeeper'
    },

    {
      id: 4,
      model: 'Playmaker'
    },
    {
      id: 5,
      model: 'Defender'
    },
    {
      id: 6,
      model: 'Player'
    },
    {
      id: 7,
      model: 'personage'
    },
    {
      id: 8,
      model: 'club'
    },
    {
      id: 9,
      model: 'team'
    },
    {
      id: 10,
      model: 'tournament'
    },

  ];
  constructor(
    private route: ActivatedRoute,
    private iffhsService: IffhsService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastrService: ToastrService,

  ) { }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.getAllQuestions();
    this.route.queryParams.subscribe(params => this.id = params.id);
    this.votingQuestionForm = this.formBuilder.group({
      questionCategory: ['', Validators.required],
      questionModal: ['', Validators.required],
      questionStructure: ['', Validators.required],
      question: ['', Validators.required],
      createdBy: [this.currentUser.success.user.id],
    });
  }
  getAllQuestions() {
    this.isLoaderVisible = true;
    this.iffhsService.getAllQuestions(null).subscribe((res: any) => {
      this.questions = res.questions;
      this.items = this.questions;
      this.isLoaderVisible = false;
    });
  }
  onChangePage(pageOfItems: Array<any>) {
    this.pageOfItems = pageOfItems;
  }


  // onImageSelect(event) {
  //   const awardPhoto = event.target.files[0];
  //   const type = event.target.files[0].type;
  //   if (type.match(/image\/*/) === null) {
  //     this.toastrService.error('Only images are supported', 'Message!');
  //     return;
  //   }
  //   this.votingQuestionForm.get('awardPhoto').setValue(awardPhoto);

  // }

  onClick(add: string) {
    console.log(add);
    if (add === 'add') {
      this.domElement = add;
    } else if (add === 'view') {
      this.domElement = add;
      this.getAllQuestions();
    }
  }
  onChange(e) {
    const onChangeValue = e.target.value || 0;
    this.votingQuestionForm.get('questionCategory').setValue(onChangeValue);
  }
  openDeleteModal(modal: any, banner: any) {
    this.selectedQuestion = banner;
    modal.show();
  }
  deleteQuestion(modal: any) {
    const data = {
      questionId: this.selectedQuestion.id,
    };
    this.iffhsService.deleteQuestion(data).subscribe(
      res => {
        modal.hide();
        this.getAllQuestions();
        this.toastrService.success('Voting Question  Deleted', 'Message!');
      },
      error => {
        console.log(error);
      }
    );
  }

  get f() { return this.votingQuestionForm.controls; }
  addVotingQuestion() {
    this.submitted = true;
    this.loading = true;
    if (this.votingQuestionForm.invalid) {
      this.loading = false;
      return;
    }
    const fd = new FormData();
    fd.append('questionCategory', this.votingQuestionForm.get('questionCategory').value);
    fd.append('questionModal', this.votingQuestionForm.get('questionModal').value);
    fd.append('questionStructure', this.votingQuestionForm.get('questionStructure').value);
    fd.append('question', this.votingQuestionForm.get('question').value);
    fd.append('createdBy', this.votingQuestionForm.get('createdBy').value);

    this.iffhsService.addVotingQuestions(fd).pipe(first()).subscribe(
      data => {
        this.getAllQuestions();
        this.toastrService.success('Question Added!', 'Message!');
        this.loading = false;
        this.submitted = true;
      },
      error => {
        console.log(error);
        this.toastrService.error('Something went wrong please Try Later!', 'Message!');
        this.loading = false;
      }
    );
    this.resetForm();
  }
  resetForm() {
    this.votingQuestionForm = this.formBuilder.group({
      questionCategory: [''],
      questionModal: [''],
      questionStructure: [''],
      question: [''],
      createdBy: [this.currentUser.success.user.id],
    });
  }


}
